export enum RoleActions {
  Reset = "reset",
  FetchRoles = "fetchRoles",
  FetchRole = "fetchRole",
  AddRole = "addRole",
  EditRole = "editRole",
}
